import { createScreenView, SCREEN_VIEWS } from '@/global/composables/table/useScreenView'

/**
 * How the tasks listing splits the screen with the map.
 *
 * Opens on the split: ticking a task is there to be looked at on the map, so the map
 * is what the listing opens with. The selection is kept across a switch, so tasks are
 * ticked beside the listing and then looked at on the whole screen.
 */
export const tasksScreenView = createScreenView({
  initialView: SCREEN_VIEWS.split
})
